import { url } from '@/helpers/UrlHelpers';
import ApiEndpoints from '@/config/ApiEndpoints';
import ApiService from '@/services/ApiService';

export default class FetchProducts {
    apiService

    constructor(apiService = null) {
        this.apiService = apiService || new ApiService(process.env.VUE_APP_API_URL);
        this.apiService.enableAuth();
    }

    handle(payload) {
        let apiUrl = url(ApiEndpoints['shop']);
        apiUrl = payload ? `${apiUrl}?active_in=${payload.active_in}` : apiUrl;

        return this.apiService.get(apiUrl);
    }
}
